module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-octagon-fill-91e803c3.svg";